<script>
  import { createEventDispatcher } from 'svelte';
  import { fade, slide } from 'svelte/transition';
  import LoginBackground from './LoginBackground.svelte';
  import { loginStore } from './loginStore';
  import { loggedInUser, userHasAlias } from '../../Store/user-store';
  import { tv2Logo } from './Icons';
  import { firebaseApp } from '../../Store/firebase-store';
  import { addAlias, checkAlias } from '../../Api/api';
  import Spinner from '../Common/Spinner.svelte';

  const dispatch = createEventDispatcher();

  let showSpinner = false;

  const saveSumoAlias = async (userId, alias) => {
    const msg = validateAlias(alias);
    if (!msg) {
      showSpinner = true;
      try {
        const res = await checkAlias(alias, $firebaseApp);
        if (res.empty) {
          await addAlias(userId, alias, $firebaseApp);
          await $loggedInUser.updateProfile({
            displayName: alias
          });
          dispatch('user-has-alias');
        } else {
          loginStore.setErrorMessage('Alias er tatt.');
        }
      } catch (err) {
        loginStore.setErrorMessage(err);
        showSpinner = false;
      }
      showSpinner = false;
    } else {
      loginStore.setErrorMessage(msg);
    }
  };

  const onSaveAlias = async () => {
    if ($loggedInUser.displayName !== $loginStore.chatAlias) {
      await saveSumoAlias($loggedInUser.uid, $loginStore.chatAlias);
    } else {
      dispatch('user-has-alias');
    }
  };

  const validateAlias = (alias) => {
    if (alias.length <= 1) {
      return 'Alias må være minst to karakterer';
    } else if (alias.length > 20) {
      return 'Alias kan ikke være lengre enn 20 karakterer';
    }
    return '';
  };
</script>

<div class="sumo-login-alias-container" in:slide>
  <LoginBackground icon={tv2Logo} on:close={() => dispatch('close')} />
  <div class="content">
    {#if showSpinner}
      <div class="spinner">
        <Spinner color="#222222" />
      </div>
    {:else}
      <h1 class="sumo-user-label">
        {`Velkommen ${$userHasAlias ? 'tilbake' : 'inn'}!`}
      </h1>
      {#if $userHasAlias}
        <h1 class="sumo-user-label">Ditt chat-kallenavn:</h1>
      {:else}
        <h1 class="sumo-user-label">Hva skal vi kalle deg?</h1>
      {/if}
      <input
        type="search"
        autocomplete="off"
        id="alias"
        name="alias"
        placeholder="Chat-kallenavn (alias)"
        bind:value={$loginStore.chatAlias}
        on:change={() => loginStore.setErrorMessage('')}
      /><button on:click={onSaveAlias} class="joinChatBtn"
        >Bli med i chatten</button
      >
      <div class="error">{$loginStore.errorMessage}</div>
    {/if}
  </div>
</div>

<style src="./sumoAlias.scss"></style>
